import React, { useEffect, useRef } from 'react';

function Testimonials() {
  const testimonials = [
    {
      quote:
        "“Targeting consultation discover apartments. Death yet way ndulgence off under folly death wrote cause her yet way yet wayspite. Plan upon yet way get cold spot its week. Almost do am or limits hearts.”",
      author: "Daniyel karlos",
      title: "Ceo & Founder",
    },
    {
      quote:
        "“Another testimonial example for variety. We loved the experience and the service was exceptional. Highly recommend to everyone looking for a great travel adventure.”",
      author: "Jane Smith",
      title: "Travel Enthusiast",
    },
  ];

  const swiperRef = useRef(null);

  useEffect(() => {
    if (swiperRef.current && window.Swiper) {
      new window.Swiper(swiperRef.current, {
        slidesPerView: 1,
        loop: true,
        autoplay: {
          delay: 5000,
        },
        navigation: {
          nextEl: '.array-prev',
          prevEl: '.array-next',
        },
      });
    }
  }, []);

  return (
    <section className="testimonial-section2 section-padding fix">
      <div className="container">
        <div className="row g-4 align-items-center">
          <div className="col-lg-4">
            <div className="content-left">
              <img src="./assets/img/testimonial/rivews-img.png" alt="Reviews" />
              <h3>More than 25K clients <br /> Reviews</h3>
              <div className="btn-wrap">
                <div className="array-prev">
                  <img src="./assets/img/icon/left-arrow.svg" alt="Previous" />
                </div>
                <div className="array-next">
                  <img src="./assets/img/icon/right-arrow.svg" alt="Next" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-8">
            <div className="testi-new-conetent">
              <div className="section-title">
                <span className="sub-title style-2 wow fadeInUp">
                  Testimonial
                </span>
                <h2 className="wow fadeInUp" data-wow-delay=".3s">
                  What Our Clients <br /> Say About Us
                </h2>
              </div>
              <div className="row g-4 mt-2">
                <div className="col-md-4">
                  <div className="thumb">
                    <img src="./assets/img/testimonial/6.jpg" alt="Testimonial" />
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="swiper testimonial-slider2" ref={swiperRef}>
                    <div className="swiper-wrapper">
                      {testimonials.map((testimonial, index) => (
                        <div className="swiper-slide" key={index}>
                          <div className="content-right">
                            <div className="icon">
                              <img src="./assets/img/icon/qoute-2.svg" alt="Quote" />
                            </div>
                            <p>{testimonial.quote}</p>
                            <div className="info">
                              <h3>{testimonial.author}</h3>
                              <p>{testimonial.title}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;